export default __webpack_public_path__ + "static/media/donation hand.39aa4536.png";